import React, { useEffect, useRef, useState } from 'react'
import {Box, Grid, GridItem, Heading, IconButton, Image, Input, Tab, TabList, TabPanel, TabPanels, Tabs} from '@chakra-ui/react'
import { bindActionCreators } from 'redux';
import {useHistory, Link} from 'react-router-dom'
import * as routesNames from '../../../../constants/routes'
import { ActionCreators } from '../../../../redux/actions';
import { connect, useSelector } from 'react-redux';
import NavBar from '../../../elements/NavBar';
import { removeAll } from '../../../../utilities/authUtils';
import ProfilePersonalDetails from './ProfilePersonalDetails';
import ProfileBankDetails from './ProfileBankDetails';
import ProfileDocumentDetails from './ProfileDocumentDetails'
import ProfileEscrowDetails from './ProfileEscrowDetails';
import UserIcon from "../../../../assets/images/userIcon.svg";
import CameraIcon from "../../../../assets/images/camera.svg";
import Loader from '../../../elements/loader';
import ProfileSidebar from './ProfileSidebar';
import { uploadProfilePhoto } from '../../../../services/masterServices';
import CustomToast from '../../../elements/customToast';
import ImportantDialog from '../../../elements/ImportantDialog';
import IconkYC from '../../../../assets/images/Iconkyc.svg'
import DeleteAccount from '../../../modules/DeleteAccount/DeleteAccount';
import SetPin from '../../../modules/SetPin/SetPin';
import OpenFileDialogAdmin from '../../../elements/OpenFileDialogAdmin';
import { ViewIcon } from '@chakra-ui/icons';
import { detectFileType } from '../../../../utilities/DownloadDocuments';

const tabNames = [
  {
      id: 1,
      name: 'Personal Details',
  },
  {
      id: 2,
      name: 'Bank Details',
  },
  {
      id: 3,
      name: 'Documents Details',
  },
  {
    id: 4,
    name: 'Escrow Account Details',
  },
]

const InvestorProfile = (props) => {

  const history = useHistory()
  const {addToast} = CustomToast()
  const photoRef = useRef()
  const masterState = useSelector((state) => state.masterState)
  const investorState = useSelector((state) => state.investorState)
  const kycState = useSelector((state) => state.kycState)
  const [openNominee, setOpenNominee] = useState(false)
  const [unmaskedData, setUnmaskedData] = useState(null)
  const [inputValues, setInputValues] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [openDeleteAccount, setOpenDeleteAccount] = useState(false)
  const [openSetPin, setOpenSetPin] = useState(false)
  const userData = masterState?.getCurrentUserDetails?.data?.data
  const userDetails = investorState?.getInvestorDashboardData?.data?.data
  const isKYCUnderReview = (userDetails?.user?.iskyc === 0 && userDetails?.user?.form_completed_status === 1)
  const isKYCPending = (userDetails?.user?.iskyc === 0 && userDetails?.user?.form_completed_status === 0)
  const [currentFileType, setCurrentFileType] = useState(null)
  const [imageopen, setImageopen] = useState(false)
  const [modalData, setModalData] = useState(null)
  useEffect(() => {
    props.actions.getCurrentUserDetailsAction()
    props.actions.getInvestorDetailedAction()
  }, []);

  useEffect(() => {
    setInputValues({...inputValues,
      full_name: userData?.[0]?.nominee_data?.full_name,
      pan: userData?.[0]?.nominee_data?.pan,
      dob: userData?.[0]?.nominee_data?.dob,
      email: userData?.[0]?.nominee_data?.email,
      address: userData?.[0]?.nominee_data?.address,
    })
  }, [userData])

  useEffect(() => {
    if(investorState?.postNomineeDetails?.data?.success === true) {
      addToast({ message: investorState?.postNomineeDetails?.data?.message, status: 'success' })
      setOpenNominee(false)
      props?.actions?.cleanUpToast()
    } else if(investorState?.postNomineeDetails?.data?.success === false) {
      addToast({ message: investorState?.postNomineeDetails?.data?.message, status: 'error' })
      props?.actions?.cleanUpToast()
    }
  }, [investorState?.postNomineeDetails])

  useEffect(() => {
    if (kycState?.getPiiData?.data?.success === true) {
      setUnmaskedData(kycState?.getPiiData?.data?.data)
    }
  }, [kycState?.getPiiData])

  const handleNominee = () => {
    setOpenNominee(!openNominee)
  }

  const handleChange = (e) => {
    const {name, value} = e.target
    if (name === 'pan') {
      const truncatedPAN = value.slice(0, 10);
      setInputValues({ ...inputValues, [name]: truncatedPAN.toUpperCase() });
    } else {
      setInputValues({...inputValues, [name]: value})
    }
  }

  const handleShowDetails = (item) => {
    const dataMap = {
      personal_details: 'personal_details,nominee_details',
      bank_details: 'bank_details',
      doc_details: 'doc_details',
      escrow_details: 'escrow_details,escrow_account_id',
    }
    if (dataMap[item]) {
      const data = {
        accessed_data: dataMap[item],
        accessed_user: userData?.[0]?.id,
      }
      props.actions.getPiiDataAction(data)
    }
  }

  const showOpenFileDialog = () => {
    photoRef.current.click()
  }

  const onChangeFile = (e) => {
    const formData = new FormData()
    formData.append('photo', e.target.files[0])
    setIsLoading(true)
    uploadProfilePhoto(formData).then((res) => {
      setIsLoading(false)
      if (res?.data?.success === true) {
        addToast({message: res?.data?.message, status: 'success'})
        props.actions.getCurrentUserDetailsAction()
      } else if (res?.data?.success === false) {
        addToast({message: res?.data?.message, status: 'error'})
      }
    }).catch((error) => {
      addToast({message: error, status: 'error'})
      setIsLoading(false)
    })
  }

  const handleSubmit = () => {
    // let panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/
    if (!inputValues?.full_name) {
      addToast({message: 'Please Enter Name', status: 'error'})
      return
    }
    if (!inputValues?.pan) {
      addToast({message: 'Please Enter PAN Number', status: 'error'})
      return
    }
    // if (!panRegex.test(inputValues?.pan)) {
    //   addToast({message: 'Not a valid pan card number', status: 'error'})
    //   return
    // }
    if (!inputValues?.dob) {
      addToast({message: 'Please Enter Date of Birth', status: 'error'})
      return
    }
    if (!inputValues?.email) {
      addToast({message: 'Please Enter Email Address', status: 'error'})
      return
    }
    if (!inputValues?.address) {
      addToast({message: 'Please Enter Full Address', status: 'error'})
      return
    }
    const formData = {
      full_name: inputValues?.full_name,
      pan: inputValues?.pan,
      dob: inputValues?.dob,
      email: inputValues?.email,
      address: inputValues?.address
    }
    props.actions.postNomineeDetailsAction(formData)
  }

  const handleOpenDeleteAccount = () => {
    setOpenDeleteAccount(true)
  }

  const handleCloseDeleteAccount = () => {
    setOpenDeleteAccount(false)
  }

  const handleOpenSetPin = () => {
    setOpenSetPin(true)
  }

  const handleCloseSetPin = () => {
    setOpenSetPin(false)
  }

  const handleProfile = () => {
    history.push(routesNames.INVESTORPROFILE)
  }

  // const handleLogout = () => {
  //   removeAll()
  //   history.push(routesNames.LOGIN)
  // }
  const fileType = {
    photo: detectFileType(userData?.data?.photo)
  }
  const handleimageOpen = (data, fileType)=>{
    const handleimageOpen = (data, fileType)=>{
      if(!userData?.[0]?.photo){
        addToast({message: 'Please Upload your photo', status: 'error'})
        return;
      }
        setImageopen(!imageopen)
        setModalData(data)
        setCurrentFileType(fileType)
    }
  }
  return (
    <>
      {(isLoading || masterState?.getCurrentUserDetails?.loading || investorState?.postNomineeDetails?.loading || kycState?.getPiiData?.loading) &&
        <div>
          <Loader />
        </div>
      }
      <Box className='dashboard_box bg_shadow'>
        <Grid className="main_grid_container align-items-center">
          <GridItem colSpan={8}>
            <Box className='d-flex align-items-center justify-content-between'>
              <Heading as="h2" className='font-poppins page_heading'>Profile</Heading>
              <ImportantDialog data={userData?.[0]?.usertype} />
            </Box>
          </GridItem>
          <GridItem colSpan={4}>
              <NavBar handleProfile={handleProfile} data={userData} />
          </GridItem>
        </Grid>
        <Grid className="main_grid_container">
          <GridItem colSpan={8} className='details_left_grid'>
            <Box className='change_profile' mt={5} mb={8}>
              <Box className='change_profile_container'>
                <Image src={userData?.[0]?.photo ? userData?.[0]?.photo : UserIcon} className="change_profile_image" />
                <IconButton onClick={() => handleimageOpen(userData?.[0]?.photo, fileType.photo)} className="icon_button_view_photo" 
                                    icon={<ViewIcon />} />
                <IconButton className='upload_profile_icon' onClick={() => showOpenFileDialog()}>
                  <Image src={CameraIcon} />
                </IconButton>
                <Input
                  size="md"
                  name="upload"
                  type="file"
                  accept="image/*"
                  onChange={(e) => onChangeFile(e)}
                  className="d-none"
                  ref={photoRef}
                />
              </Box>
              <Box className='user_change_profile'>
                <Heading as="h3" className='font-poppins'>{`${userData?.[0]?.first_name}${' '}${userData?.[0]?.last_name}`}</Heading>
                <Heading as="h5" className='font-poppins'>Investor ID: <span>{userData?.[0]?.id}</span></Heading>
              </Box>
            </Box>
            {isKYCUnderReview ?
              <Box mt={4} className='kyc_verify'>
                <Heading as="h3" className='font-poppins'>
                  <Image src={IconkYC} />
                  Your documents under review
                  <Link to={routesNames.INVESTERKYC}>Tap to check your documents</Link>
                </Heading>
              </Box> : isKYCPending ?
              <Box mt={4} className='kyc_verify'>
                <Heading as="h3" className='font-poppins'>
                  <Image src={IconkYC} />
                  Your ALPHAMONEY account needs Verification,
                  <Link to={routesNames.INVESTERKYC}>Tap to start your KYC</Link>
                </Heading>
              </Box> : null
            }
            <Box mt={6}>
              <Tabs className='tabs_container'>
                  <TabList className='tabs_list'>
                      {tabNames.map((item, index) => {
                        return (
                          <Tab key={index}>{item.name}</Tab>
                        )
                      })}
                  </TabList>
                  <TabPanels>
                      {tabNames.map((item, index) => {
                        return (
                          <TabPanel key={index} className='tab_panel'>
                            {item.name === 'Personal Details' &&
                              <ProfilePersonalDetails userData={userData} openNominee={openNominee} handleNominee={handleNominee}
                                handleChange={handleChange} inputValues={inputValues} handleSubmit={handleSubmit}
                                handleShowDetails={handleShowDetails} unmaskedData={unmaskedData}
                              />
                            }
                            {item.name === 'Bank Details' && <ProfileBankDetails userData={userData}
                              handleShowDetails={handleShowDetails} unmaskedData={unmaskedData}
                            />}
                            {item.name === 'Documents Details' && <ProfileDocumentDetails userData={userData}
                              handleShowDetails={handleShowDetails} unmaskedData={unmaskedData}
                            />}
                            {item.name === 'Escrow Account Details' && <ProfileEscrowDetails userData={userData}
                              handleShowDetails={handleShowDetails} unmaskedData={unmaskedData}
                            />}
                          </TabPanel>
                        )
                      })}
                  </TabPanels>
              </Tabs>
            </Box>
          </GridItem>
          <GridItem colSpan={4}>
            <ProfileSidebar handleOpenDeleteAccount={handleOpenDeleteAccount} handleOpenSetPin={handleOpenSetPin} />
          </GridItem>
        </Grid>
      </Box>
      {
            imageopen && (
                <OpenFileDialogAdmin  handleimageOpen={handleimageOpen} imageopen={imageopen} fileType={currentFileType} modalData={modalData} />

            )
        }
      <DeleteAccount openDeleteAccount={openDeleteAccount} handleCloseDeleteAccount={handleCloseDeleteAccount} />
      <SetPin openSetPin={openSetPin} handleCloseSetPin={handleCloseSetPin} />
    </>
  )
}
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ActionCreators, dispatch),
})

export default connect(null, mapDispatchToProps)(InvestorProfile)